export default __webpack_public_path__ + "static/media/bicicletero.64560d52.svg";